var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side-box"},[_c('div',{staticClass:"side-box-header flex"},[_c('div',{staticClass:"side-box-title"},[_vm._t("title")],2),_c('div',{staticClass:"side-box-close"},[_c('i',{staticClass:"el-icon-close",on:{"click":_vm.close}})])]),_c('div',{staticClass:"side-box-content"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }